const endpoint = `${
  process.env.REACT_APP_ENDPOINT_LAMBDA_USER_PROFILE
}/notifications`;

export default endpoint;
